import isEmpty from '../../utility/isEmpty'
import { defaultObj } from './state'

export default {
  setLoans (state, loans) {
    if (loans) {
      state.loans = loans
    }
  },

  updateLoan (state, loan) {
    state.loans = state.loans.map((loanFromState) => {
      if (loanFromState.loanId === loan.loanId) {
        return loan
      } else {
        return loanFromState
      }
    })
  },

  updateApplications (state, applicationStatus) {
    if (applicationStatus && applicationStatus.appStatus) {
      if (applicationStatus.appStatus.TLXe) {
        state.activeApplication = applicationStatus.appStatus.TLXe.activeApplication || {}
        state.declinedTlxeApplications = isEmpty(applicationStatus.appStatus.TLXe.declinedResults) ? [] : applicationStatus.appStatus.TLXe.declinedResults.map(app => app.applicationLoanInfo)
        state.expressApplicationUrl = applicationStatus.appStatus.TLXe.expressApplicationUrl
      }
    } else {
      state.declinedTlxeApplications = []
    }
  },

  setPendingRefiInfo (state, pendingRefiInfo) {
    if (pendingRefiInfo) {
      state.pendingRefiInfo = pendingRefiInfo
    }
  },

  setPendingReapplyInfo (state, pendingReapplyInfo) {
    if (pendingReapplyInfo) {
      state.pendingReapplyInfo = pendingReapplyInfo
    }
  },

  setDashboardSeeMoreInfo (state, dashboardShowMoreInfo) {
    if (!isEmpty(dashboardShowMoreInfo.hasMoreOpenLoans)) {
      state.hasMoreOpenLoans = dashboardShowMoreInfo.hasMoreOpenLoans
    }
    if (!isEmpty(dashboardShowMoreInfo.hasMoreClosedLoans)) {
      state.hasMoreClosedLoans = dashboardShowMoreInfo.hasMoreClosedLoans
    }
    if (!isEmpty(dashboardShowMoreInfo.hasMoreDeclinedResults)) {
      state.hasMoreDeclinedResults = dashboardShowMoreInfo.hasMoreDeclinedResults
    }
  },

  setCreditLimitModal (state, value) {
    state.showCreditLimitModal = value
  },

  setRateChangeModal (state, data) {
    state.showRateChangeModal = data
  },

  setRefinanceDenial (state, data) {
    state.refinanceDenied = data
  },

  resetLoans (state) {
    state.loans = []
  },

  reset (state) {
    if (this.cache.has('loans/getLoans') === true) {
      this.cache.delete('loans/getLoans')
    }

    state = Object.assign(state, defaultObj)
  },

  setReapplyInfo (state, reapplyInfo) {
    state.reapplyInfo = !isEmpty(reapplyInfo) ? reapplyInfo : state.reapplyInfo
  }
}
